import { SvgIcon, SvgIconProps } from '@mui/material';

const Failed = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 16, height: 16, fill: 'none', ...sx }}
      data-testid="failedIcon"
      titleAccess="failed"
      {...props}
    >
      <path
        d="M6.65307 7.99994L3.28589 11.3671C2.91396 11.739 2.91396 12.3421 3.28589 12.714C3.65782 13.0859 4.26083 13.0859 4.63276 12.714L7.99994 9.34681L11.3671 12.714C11.739 13.0859 12.3421 13.0859 12.714 12.714C13.0859 12.3421 13.0859 11.739 12.714 11.3671L9.34681 7.99994L12.714 4.63276C13.0859 4.26083 13.0859 3.65782 12.714 3.28589C12.3421 2.91396 11.739 2.91396 11.3671 3.28589L7.99994 6.65307L4.63276 3.28589C4.26083 2.91396 3.65782 2.91396 3.28589 3.28589C2.91396 3.65782 2.91396 4.26083 3.28589 4.63276L6.65307 7.99994Z"
        fill="#D52B1E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.97162 2.97162C3.51712 2.42613 4.40154 2.42613 4.94703 2.97162L7.99994 6.02453L11.0528 2.97162C11.5983 2.42613 12.4828 2.42613 13.0282 2.97162C13.5737 3.51712 13.5737 4.40154 13.0282 4.94703L9.97534 7.99994L13.0282 11.0528C13.5737 11.5983 13.5737 12.4828 13.0282 13.0282C12.4828 13.5737 11.5983 13.5737 11.0528 13.0282L7.99994 9.97535L4.94703 13.0282C4.40154 13.5737 3.51711 13.5737 2.97162 13.0282C2.42613 12.4828 2.42613 11.5983 2.97162 11.0528L6.02453 7.99994L2.97162 4.94703C2.42613 4.40154 2.42613 3.51712 2.97162 2.97162ZM4.31849 3.60016C4.12013 3.4018 3.79852 3.4018 3.60016 3.60016C3.4018 3.79852 3.4018 4.12013 3.60016 4.31849L7.2816 7.99994L3.60016 11.6814C3.4018 11.8797 3.4018 12.2013 3.60016 12.3997C3.79852 12.5981 4.12013 12.5981 4.31849 12.3997L7.99994 8.71827L11.6814 12.3997C11.8797 12.5981 12.2013 12.5981 12.3997 12.3997C12.5981 12.2013 12.5981 11.8797 12.3997 11.6814L8.71827 7.99994L12.3997 4.31849C12.5981 4.12013 12.5981 3.79852 12.3997 3.60016C12.2013 3.4018 11.8797 3.4018 11.6814 3.60016L7.99994 7.28161L4.31849 3.60016Z"
        fill="#D52B1E"
      />
    </SvgIcon>
  );
};

export default Failed;
